import axios from "axios";
import { useMutation, useQuery } from "react-query"
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import { Badge, Breadcrumb, Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useEffect, useState } from "react";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import * as moment from "moment";
import AddEditVisual from "./AddEditVisual";
import { confirmAlert } from "react-confirm-alert";


export default function () {

    const [visuals, setVisuals] = useState({})
    const [currentPath, setCurrentPath] = useState("Home")
    const [selectedVisual, setSelectedVisual] = useState([])
    const [visualToEdit, setVisualToEdit] = useState(null)
    const [showAddEditVisualModal, setShowAddEditVisualModal] = useState(false)

    const getVisuals = useQuery("getVisuals", async () => {
        let resp = await axios.get(`${DEV_SERVER}/visuals/v2`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {

                setVisuals(data.data);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updateVisualMutation = useMutation((data) => axios.put(`${DEV_SERVER}/visuals/v2`, data, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data?.data?.status) {
                toast.success(data.data.message)
                setVisuals(data?.data?.data)
                setShowAddEditVisualModal(false)
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message)
            } else {
                toast.error("Something went wrong")
            }
        }
    })

    const handleUpdateFolder = async (data, oldName) => {
        console.log("Data ", data);
        let _visuals = { ...visuals }; // Create a shallow copy to avoid mutating the original object
        let temp = _visuals?.childs || [];
        let path = currentPath.split("/");

        let parent = null; // To keep track of the parent reference
        let parentChilds = temp; // Reference to the parent's `childs` array

        path.forEach((p) => {
            if (p === "Home") {
                return;
            }

            for (let i = 0; i < parentChilds.length; i++) {
                if (parentChilds[i]?.name === p) {
                    parent = parentChilds[i]; // Update parent reference
                    parentChilds = parentChilds[i]?.childs || []; // Update parentChilds to the next level
                    break;
                }
            }
        });

        if (!parentChilds) {
            parentChilds = [];
        }

        let flag = false;
        for (let i = 0; i < parentChilds.length; i++) {
            if (parentChilds[i]?.name === oldName) {
                parentChilds[i] = {
                    ...data,
                    updatedAt: moment(Date.now()).valueOf(),
                    childs: parentChilds[i]?.childs || []
                };
                flag = true;
                break;
            }
        }

        if (!flag) {
            parentChilds.push(data);
        }

        if (parent) {
            parent.childs = parentChilds; // Ensure the parent's `childs` is updated
        } else {
            _visuals.childs = parentChilds; // If no parent, update the root level
        }

        console.log("_Visuals ", _visuals);
        updateVisualMutation.mutate(_visuals);
    };

    const handleUpdateVisuals = async (data) => {
        console.log("Data ", data);
        let _visuals = { ...visuals }; // Create a shallow copy to avoid mutating the original object
        let temp = _visuals?.childs || [];
        let path = currentPath.split("/");

        let parent = null; // To keep track of the parent reference
        let parentChilds = temp; // Reference to the parent's `childs` array

        path.forEach((p) => {
            if (p === "Home") {
                return;
            }

            for (let i = 0; i < parentChilds.length; i++) {
                if (parentChilds[i]?.name === p) {
                    parent = parentChilds[i]; // Update parent reference
                    parentChilds = parentChilds[i]?.childs || []; // Update parentChilds to the next level
                    break;
                }
            }
        });

        if (!parentChilds) {
            parentChilds = [];
        }

        // data is an array of objects

        parentChilds = [...parentChilds, ...data];

        if (parent) {
            parent.childs = parentChilds; // Ensure the parent's `childs` is updated
        } else {
            _visuals.childs = parentChilds; // If no parent, update the root level
        }

        console.log("_Visuals ", _visuals);

        updateVisualMutation.mutate(_visuals);
    }

    useEffect(() => {
        getVisuals.refetch({ cancelRefetch: true });
    }, [])

    useEffect(() => {
        let _visuals = { ...visuals }; // Create a shallow copy to avoid mutating the original object
        let temp = _visuals?.childs || [];

        let parent = null; // To keep track of the parent reference
        let parentChilds = temp; // Reference to the parent's `childs` array

        currentPath.split("/").forEach((p) => {
            if (p === "Home") {
                return;
            }

            for (let i = 0; i < parentChilds.length; i++) {
                if (parentChilds[i]?.name === p) {
                    parent = parentChilds[i]; // Update parent reference
                    parentChilds = parentChilds[i]?.childs || []; // Update parentChilds to the next level
                    break;
                }
            }
        })

        setSelectedVisual(parentChilds)
    }, [visuals])

    const columns = [
        {
            name: "Name",
            selector: "name",
            cell: (row) => {
                return <span>{row?.name}</span>
            }
        },
        {
            name: "Type",
            selector: "type",
            cell: (row) => {
                if (row?.type === "folder") {
                    return <Badge variant="primary">Folder</Badge>
                }

                return <Badge bg="info">Visual</Badge>
            }
        },
        {
            name: "Media",
            color: true,
            center: true,
            selector: (row) => {
                console.log("Row ", row)
                if (row?.type === "folder") {
                    return <span></span>
                }

                return <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    <Zoom key={row?._id}><img src={row?.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>
                </div>
            }
        },
        {
            name: "Last Modified",
            selector: "updatedAt",
            cell: (row) => {
                return moment(row?.updatedAt).format("DD/MM/YY hh:mm A")
            }
        },
        {
            name: "Action",
            center: true,
            selector: (row) => {
                return <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                    {row?.type === "folder" && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            setVisualToEdit(row)
                            setShowAddEditVisualModal(true)
                        }}><i className="far fa-edit table-icons"></i></span>
                    </OverlayTrigger>}
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {

                            confirmAlert({
                                title: 'Confirm to delete',
                                message: 'Are you sure you want to delete this visual?',
                                buttons: [
                                    {
                                        label: 'Yes',
                                        onClick: () => {
                                            let _visuals = { ...visuals }; // Create a shallow copy to avoid mutating the original object
                                            let temp = _visuals?.childs || [];
                                            let path = currentPath.split("/");

                                            let parent = null; // To keep track of the parent reference
                                            let parentChilds = temp; // Reference to the parent's `childs` array

                                            path.forEach((p) => {
                                                if (p === "Home") {
                                                    return;
                                                }

                                                for (let i = 0; i < parentChilds.length; i++) {
                                                    if (parentChilds[i]?.name === p) {
                                                        parent = parentChilds[i]; // Update parent reference
                                                        parentChilds = parentChilds[i]?.childs || []; // Update parentChilds to the next level
                                                        break;
                                                    }
                                                }
                                            })

                                            parentChilds = parentChilds.filter((item) => item?.name !== row?.name)

                                            if (parent) {
                                                parent.childs = parentChilds; // Ensure the parent's `childs` is updated
                                            } else {
                                                _visuals.childs = parentChilds; // If no parent, update the root level
                                            }

                                            updateVisualMutation.mutate(_visuals);
                                        }
                                    },
                                    {
                                        label: 'No',
                                        onClick: () => { }
                                    }
                                ]
                            });
                        }}><i className="far fa-trash-alt table-icons"></i></span>
                    </OverlayTrigger>
                </div>
            }
        }
    ]


    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Visuals</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="d-flex justify-content-between align-items-center">
                                    <Breadcrumb>
                                        {currentPath.split("/").map((path, index) => {
                                            return (
                                                <Breadcrumb.Item key={index} onClick={() => {
                                                    let newPath = currentPath.split("/").slice(0, index + 1).join("/")
                                                    setCurrentPath(newPath)

                                                    let _visuals = { ...visuals }; // Create a shallow copy to avoid mutating the original object
                                                    let temp = _visuals?.childs || [];

                                                    let parent = null; // To keep track of the parent reference
                                                    let parentChilds = temp; // Reference to the parent's `childs` array

                                                    newPath.split("/").forEach((p) => {
                                                        if (p === "Home") {
                                                            return;
                                                        }

                                                        for (let i = 0; i < parentChilds.length; i++) {
                                                            if (parentChilds[i]?.name === p) {
                                                                parent = parentChilds[i]; // Update parent reference
                                                                parentChilds = parentChilds[i]?.childs || []; // Update parentChilds to the next level
                                                                break;
                                                            }
                                                        }
                                                    })

                                                    setSelectedVisual(parentChilds)

                                                }}>{path}</Breadcrumb.Item>
                                            )
                                        }
                                        )}
                                    </Breadcrumb>

                                    <div>
                                        <button onClick={() => {
                                            setVisualToEdit(null)
                                            setShowAddEditVisualModal(true)
                                        }} className="btn btn-primary">
                                            <i className="fas fa-plus"></i>
                                            <span className="ms-1">Add Visual</span>
                                        </button>
                                    </div>
                                </div>

                                <Row>
                                    <Card >
                                        <Card.Body>
                                            {(!getVisuals.isLoading && !getVisuals?.isFetching) &&
                                                <DataTable
                                                    columns={columns}
                                                    data={selectedVisual}
                                                    customStyles={{
                                                        rows: {
                                                            style: {
                                                                cursor: "pointer",
                                                                backgroundColor: "unset"
                                                            }
                                                        }
                                                    }}
                                                    onRowClicked={(row) => {
                                                        if (row?.type === "folder") {
                                                            setCurrentPath(`${currentPath}/${row?.name}`)
                                                            setSelectedVisual(row?.childs || [])
                                                        }
                                                    }}
                                                    pagination={true}
                                                    paginationPerPage={35}
                                                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                                />}
                                            {(getVisuals.isLoading || getVisuals?.isFetching) && <div className="d-flex justify-content-center">
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>}
                                        </Card.Body>
                                    </Card>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {showAddEditVisualModal && <AddEditVisual show={showAddEditVisualModal} handleUpdateVisuals={(data) => handleUpdateVisuals(data)} handleUpdateFolder={(data, oldName) => handleUpdateFolder(data, oldName)} close={() => setShowAddEditVisualModal(false)} visual={visualToEdit} />}
            </div>
        </>
    )
}